<template>
  <ViewEntityContainer :entityName="entityName" :identifier="$route.params.departmentId"
    :getMethod="getDepartmentById" :refreshOnTimestamp="true" :notificationListeners="[srEventKey]"
    :notificationValidator="notificationValidator">
  </ViewEntityContainer>
</template>

<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import SRConst from "@/helpers/Constants/SignalRConstants.js";
import ViewEntityContainer from "@/views/pim/suppliers/ViewEntityContainer.vue";
import EntityNames from "@/helpers/Constants/EntityNames.js";

export default {
  name: "ViewDepartmentContainer",
  components: {
    ViewEntityContainer,
  },
  mixins: [clientAPI],

  data() {
    return {
      entityName: EntityNames.Department
    };
  },

  mounted() { },

  methods: {
    notificationValidator(args, identifier) {
      return args && args.departmentId == identifier;
    },
  },

  computed: {
    srEventKey() {
      return SRConst.EventKeys.DepartmentChange;
    },
  },

  watch: {},
};
</script>

<style lang="scss" scoped></style>